import { render, staticRenderFns } from "./order.vue?vue&type=template&id=44dcfa50&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44dcfa50')) {
      api.createRecord('44dcfa50', component.options)
    } else {
      api.reload('44dcfa50', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=44dcfa50&", function () {
      api.rerender('44dcfa50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/drop-out/components/order.vue"
export default component.exports